import { PropsWithChildren } from 'react';
import OxDataGrid, {
  OxDataGridProps,
} from '../../../../elements/OxDataGrid/OxDataGrid';
import config from '../../config/issues-config.json';
import { Issue } from '../../types/issues-types';

const BaseIssuesTable = (props: PropsWithChildren<OxDataGridProps<Issue>>) => {
  return (
    <OxDataGrid
      rowHeight={config.table.rowHeight}
      defaultColumnOptions={{
        resizable: false,
      }}
      {...props}
    />
  );
};

export default BaseIssuesTable;
